import axios from "axios"
export const ClientList = async() => {
    try {
        const response = await axios.get('https://land-survey-main-server.onrender.com/getClient');
        if(response){
                   if(response.data && response.data.clients){
            return response.data.clients;
            }
        }
    } catch (err) {
        if(err.message){
            console.log(err.message);
        }
         return [];
    }
}